import * as React from 'react';
import * as _ from 'lodash';
import Pager from '../PageLayout/Pager2';
import CheckBox from '../PageLayout/CheckBox';
import classNames from 'classnames';
export default function () {
    function onClick1(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, e) {
        {
            handleSortBy(e, 'fabricator');
        }
    }
    function onClick2(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, e) {
        {
            handleSortBy(e, 'name');
        }
    }
    function onClick3(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, e) {
        {
            handleSortBy(e, 'enabled');
        }
    }
    function onClick4(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, e) {
        {
            handleSortBy(e, 'kv');
        }
    }
    function onClick5(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex) {
        this.handleDeleteSite(site);
    }
    function onChange6(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex, e) {
        handleInputChange(e, site);
    }
    function onChecked7(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex) {
        this.toggleQuickQuoteEnabled(site);
    }
    function onChecked8(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex) {
        this.toggleKitchenVisualizerEnabled(site);
    }
    function repeatSite9(sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex) {
        return React.createElement('li', {
            'className': 'users-sites-list__item',
            'key': siteIndex
        }, React.createElement('div', { 'className': 'users-sites-remove' }, React.createElement('button', {
            'className': 'users-sites-remove__button ui-icon-remove',
            'onClick': onClick5.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex)
        })), React.createElement('div', { 'className': 'users-sites-title' }, site.fabricatorName), React.createElement('div', { 'className': 'users-sites-subdomain' }, React.createElement('div', { 'className': 'users-sites-input' }, React.createElement('input', {
            'type': 'text',
            'className': classNames('users-sites-subdomain__input', 'ui-input', 'ui-input--gray', {
                'ui-input--error': !!site.errorMessage,
                'ui-input--touched': site.changed
            }),
            'onChange': onChange6.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex),
            'value': site.subDomain || ''
        }), site.errorMessage !== '' ? React.createElement('p', {
            'className': 'users-sites-subdomain__error',
            'key': '3740'
        }, site.errorMessage) : null)), React.createElement('div', { 'className': 'users-sites-quick' }, React.createElement(CheckBox, {
            'onChecked': onChecked7.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex),
            'checked': site.enabled,
            'text': site.enabled ? 'Enabled' : 'Disabled',
            'textMode': 'div',
            'disabled': !site.subDomain
        })), React.createElement('div', { 'className': 'users-sites-kitchen' }, React.createElement(CheckBox, {
            'onChecked': onChecked8.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy, site, siteIndex),
            'checked': site.kitchenVisualizerEnabled,
            'text': site.kitchenVisualizerEnabled ? 'Enabled' : 'Disabled',
            'textMode': 'div',
            'disabled': !site.subDomain
        })));
    }
    function scopeSitesTotalPagesPageHandleInputChangeHandlePaginateHandleSortBy10() {
        var sites = this.props.sites;
        var totalPages = this.props.totalPages;
        var page = this.props.page;
        var handleInputChange = this.handleInputChange;
        var handlePaginate = this.handlePaginate;
        var handleSortBy = this.handleSortBy;
        return React.createElement('div', {}, React.createElement('div', { 'className': 'sites-content' }, React.createElement('div', { 'className': 'app-content-header app-content-header--fixed app-content-header--lined' }, React.createElement('div', { 'className': 'ui-container-fluid' }, React.createElement('div', { 'className': 'users-sites-sort-bar' }, React.createElement('div', {
            'onClick': onClick1.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy),
            'className': classNames('users-sites-sort-bar-col', 'users-sites-sort-bar-col--title', {
                'users-sites-sort-bar-col--active-asc': this.state.sortKeyword === 'fabricator' && this.state.sortOrder === 'asc',
                'users-sites-sort-bar-col--active-desc': this.state.sortKeyword === 'fabricator' && this.state.sortOrder === 'desc'
            })
        }, React.createElement('span', { 'className': 'users-sites-sort-bar-col-name' }, 'Fabricator / Store')), React.createElement('div', {
            'onClick': onClick2.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy),
            'className': classNames('users-sites-sort-bar-col', 'users-sites-sort-bar-col--subdomain', {
                'users-sites-sort-bar-col--active-asc': this.state.sortKeyword === 'name' && this.state.sortOrder === 'asc',
                'users-sites-sort-bar-col--active-desc': this.state.sortKeyword === 'name' && this.state.sortOrder === 'desc'
            })
        }, React.createElement('span', { 'className': 'users-sites-sort-bar-col-name' }, 'Subdomain')), React.createElement('div', {
            'onClick': onClick3.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy),
            'className': classNames('users-sites-sort-bar-col', 'users-sites-sort-bar-col--quick', {
                'users-sites-sort-bar-col--active-asc': this.state.sortKeyword === 'enabled' && this.state.sortOrder === 'desc',
                'users-sites-sort-bar-col--active-desc': this.state.sortKeyword === 'enabled' && this.state.sortOrder === 'asc'
            })
        }, React.createElement('span', { 'className': 'users-sites-sort-bar-col-name' }, 'Quick Quote')), React.createElement('div', {
            'onClick': onClick4.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy),
            'className': classNames('users-sites-sort-bar-col', 'users-sites-sort-bar-col--kitchen', {
                'users-sites-sort-bar-col--active-asc': this.state.sortKeyword === 'kv' && this.state.sortOrder === 'desc',
                'users-sites-sort-bar-col--active-desc': this.state.sortKeyword === 'kv' && this.state.sortOrder === 'asc'
            })
        }, React.createElement('span', { 'className': 'users-sites-sort-bar-col-name' }, 'Kitchen Visualizer'))))), React.createElement('div', { 'className': 'app-content-main' }, React.createElement('div', { 'className': 'users-sites-container' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'users-sites-list ui-list' },
            _.map(sites, repeatSite9.bind(this, sites, totalPages, page, handleInputChange, handlePaginate, handleSortBy))
        ]), React.createElement(Pager, {
            'totalPages': totalPages,
            'pageClick': handlePaginate,
            'color': 'green',
            'page': page
        })))));
    }
    return scopeSitesTotalPagesPageHandleInputChangeHandlePaginateHandleSortBy10.apply(this, []);
}